import { wikiToPlainText } from '@/util/tokenize_wiki_text'

/**
 * Helper function to strip HTML tags from a string
 */
export function stripHtml(html: string): string {
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

/**
 * Extract plain text from a WikiTextEditor instance
 */
export function getEditorPlainText(editor: any): string {
  const plainText = editor?.editor?.getText()
  if (!plainText) return ''
  return wikiToPlainText(plainText)
}

/**
 * Process statement text by stripping HTML and converting wiki text to plain text
 */
export function processStatementText(text: string): string {
  const htmlStripped = stripHtml(text)
  return wikiToPlainText(htmlStripped)
}
